import CoordinatorResource from './coordinator-resource';
import CoordinatorModel from './coordinator-model';
import _ from 'lodash';
import { update } from 'serializr';
import { mobx, observable, action, computed } from 'mobx';

export default class CoordinatorStore {
    @observable isLoading = true;
    @observable selectedCoordinator;
    coordinators = observable.map();
    lookupCoordinators = observable.array();
    appStore;
    coordinatorResource;

    constructor(appStore) {
        this.appStore = appStore;
        this.coordinatorResource = new CoordinatorResource();
        this.selectedCoordinator = new CoordinatorModel();
    }

    @computed get lookupCoordinatorsComputed() {
        return this.lookupCoordinators.map((e) => {
            return {
                coordinatorId: e.coordinatorId,
                name: e.name,
                aspNetUserId: e.aspNetUserId,
                email: e.email,
                displayName: e.displayName,
            };
        });
    }

    @action.bound loadCoordinators() {
        this.isLoading = true;
        this.coordinatorResource
            .getCoordinators(this.appStore.authStore.getAccessToken(), false)
            .then((coordinatorModels) => {
                this.updateCoordinators(coordinatorModels);
                this.isLoading = false;
            })
            .catch((err) => {
                // TODO add logging
                console.log('Failed to load coordinators.' + err);
            });
    }

    @action updateCoordinators(coordinatorModels) {
        coordinatorModels.forEach((newCoordinator) => {
            if (this.coordinators.has(newCoordinator.coordinatorId)) {
                const coordinator = this.coordinators.get(newCoordinator.coordinatorId);
                update(coordinator, newCoordinator);
            } else {
                this.coordinators.set(newCoordinator.coordinatorId, newCoordinator);
            }
        });
    }

    @action.bound updateSelectedCoordinatorFields(coordinator) {
        this.selectedCoordinator === coordinator;
        this.coordinatorResource.saveCoordinator(
            this.appStore.authStore.getAccessToken(),
            this.selectedCoordinator,
            coordinator
        );
    }

    @action.bound loadLookupCoordinators(query) {
        const formattedQuery = { filter: { where: { name: { ilike: `%${query}%` } } } };
        this.coordinatorResource
            .getCoordinatorsSearch(this.appStore.authStore.getAccessToken(), formattedQuery)
            .then((coordinators) => {
                this.lookupCoordinators.replace(coordinators);
            })
            .catch((err) => {
                // TODO add logging
                console.log('Failed to load fitlter coordinators.' + err);
            });
    }
}



// WEBPACK FOOTER //
// ./src/coordinators/coordinator-store.js